import { Box, Typography, useTheme } from "@mui/material";
import { awsImageRootUrl } from "lib/constants";
import { Business } from "lib/features/business/types";
import { User } from "lib/features/user/types";
import { useNavigate } from "react-router-dom";
import { businessCheckout } from "styles/Checkout/multiBusinessCheckout";
import { formatAddress } from "util/formatAddress";

interface CheckoutBusinessCardProps {
  business: Business;
  userData: User;
}

const CheckoutBusinessCard = ({
  business,
  userData,
}: CheckoutBusinessCardProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const fallbackImage = business.businessImages[0].uri
    ? `${awsImageRootUrl}/${business.businessImages[0].uri}`
    : `${awsImageRootUrl}/imageNotFound.jpg`;

  const handleBusinessClick = () => {
    const shareLink = `/business/${business?.id}?referredBy=${userData?.id
      }&showBack=${true}`;

    navigate(shareLink);
  };

  return (
    <Box sx={businessCheckout.businessCard(theme)} onClick={handleBusinessClick}>
      {/* Image Box */}
      <Box sx={businessCheckout.businessImageBox}>
        <img
          src={fallbackImage}
          alt={"image"}
          style={businessCheckout.businessImage}
        />
      </Box>

      {/* Body */}
      <Box sx={businessCheckout.cardDetails}>
        <Typography sx={businessCheckout.businessTitle}>
          {business?.business}
        </Typography>
        <Typography sx={businessCheckout.businessAddress}>
          {formatAddress(
            business?.address1,
            business?.city,
            business?.state
          )}
        </Typography>

        <Typography sx={businessCheckout.businessHeadline}>
          {business.business_headline}
        </Typography>

        <Typography
          sx={businessCheckout.businessAvailability}
        >
          CHECK AVAILABILITIES
        </Typography>
      </Box>

      {/* Details Section */}
    </Box>
  );
};

export default CheckoutBusinessCard;
